module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-7.3fcdc3eb.png";